import { render, staticRenderFns } from "./MyAbout.vue?vue&type=template&id=e8e47d2a&scoped=true"
import script from "./MyAbout.vue?vue&type=script&lang=js"
export * from "./MyAbout.vue?vue&type=script&lang=js"
import style0 from "./MyAbout.vue?vue&type=style&index=0&id=e8e47d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e47d2a",
  null
  
)

export default component.exports